/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Details_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Commit details" |
*
* @param {Snapshot_History_Details_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_details_aria_label = /** @type {((inputs?: Snapshot_History_Details_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Details_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Details du commit")
	if (locale === "de") return /** @type {LocalizedString} */ ("Details zum Commit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dettagli del commit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подробности подтверждения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detalles de la confirmación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交详情")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミットの詳細")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिबद्धता विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detalhes do compromisso")
	return /** @type {LocalizedString} */ ("Commit details")
});